export default __webpack_public_path__ + "static/media/background-test.01027909.png";